var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15319_31048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 23C9 14.1634 16.1634 7 25 7C33.8366 7 41 14.1634 41 23C41 31.8366 33.8366 39 25 39C16.1634 39 9 31.8366 9 23Z",
    fill: "#0085E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 23C9 14.1634 16.1634 7 25 7C33.8366 7 41 14.1634 41 23C41 31.8366 33.8366 39 25 39C16.1634 39 9 31.8366 9 23Z",
    stroke: "#B5E7FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1982 17.5586C21.6725 17.5586 21.2056 17.8895 21.0293 18.3874L20.2809 20.5273H29.7191L28.9707 18.3874C28.7975 17.8926 28.3275 17.5586 27.8018 17.5586H22.1982ZM17.4792 22.0117H17.3307C16.9194 22.0117 16.5885 21.6808 16.5885 21.2695C16.5885 20.8582 16.9194 20.5273 17.3307 20.5273H18.71L19.6315 17.8957C20.0119 16.804 21.0417 16.0742 22.1982 16.0742H27.8018C28.9583 16.0742 29.9881 16.804 30.3716 17.8957L31.29 20.5273H32.6693C33.0806 20.5273 33.4115 20.8582 33.4115 21.2695C33.4115 21.6808 33.0806 22.0117 32.6693 22.0117H32.5208C32.7744 22.4478 32.9167 22.9549 32.9167 23.4961V25.9701V27.4544V29.1862C32.9167 29.5975 32.5858 29.9284 32.1745 29.9284C31.7632 29.9284 31.4323 29.5975 31.4323 29.1862V27.4544H18.5677V29.1862C18.5677 29.5975 18.2368 29.9284 17.8255 29.9284C17.4142 29.9284 17.0833 29.5975 17.0833 29.1862V27.4544V25.9701V23.4961C17.0833 22.9549 17.2287 22.4478 17.4792 22.0117ZM20.0521 22.0117C19.2326 22.0117 18.5677 22.6766 18.5677 23.4961V25.9701H31.4323V23.4961C31.4323 22.6766 30.7674 22.0117 29.9479 22.0117H20.0521ZM19.5573 23.9909C19.5573 23.7284 19.6615 23.4767 19.8471 23.2911C20.0327 23.1056 20.2844 23.0013 20.5469 23.0013C20.8093 23.0013 21.061 23.1056 21.2466 23.2911C21.4322 23.4767 21.5365 23.7284 21.5365 23.9909C21.5365 24.2533 21.4322 24.505 21.2466 24.6906C21.061 24.8762 20.8093 24.9805 20.5469 24.9805C20.2844 24.9805 20.0327 24.8762 19.8471 24.6906C19.6615 24.505 19.5573 24.2533 19.5573 23.9909ZM29.4531 23.0013C29.7156 23.0013 29.9673 23.1056 30.1529 23.2911C30.3384 23.4767 30.4427 23.7284 30.4427 23.9909C30.4427 24.2533 30.3384 24.505 30.1529 24.6906C29.9673 24.8762 29.7156 24.9805 29.4531 24.9805C29.1907 24.9805 28.939 24.8762 28.7534 24.6906C28.5678 24.505 28.4635 24.2533 28.4635 23.9909C28.4635 23.7284 28.5678 23.4767 28.7534 23.2911C28.939 23.1056 29.1907 23.0013 29.4531 23.0013Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15319_31048",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.0470588 0 0 0 0 0.133333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15319_31048"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15319_31048",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryEmployee);
export default __webpack_public_path__ + "static/media/delivery-employee.a073816c.svg";
export { ForwardRef as ReactComponent };